<script setup>
import {computed} from 'vue'

const props = defineProps({
    minWidth: {
        type: String,
        default: null,
    },
    topOffset: {
        type: String,
        default: null,
    },
    class: {
        type: String,
        default: null,
    }

});

const inlineStyle = computed(() => {
    let style = "";
    if (props.minWidth) {
        style += `min-width: ${props.minWidth};`;
    }
    if (props.topOffset) {
        style += `top: ${props.topOffset}`;
    }
    return style;
});
</script>

<template>
    <div
        role="tooltip"
        :style="inlineStyle"
        :class="props.class"
        class="tooltip-box invisible absolute text-white bg-gray-900
               border border-gray-600 left-0 z-10 rounded-lg p-3"
    >
        <slot/>
    </div>
</template>
